import React from "react";
import { AppraiserPasswordSet } from "./AppraiserPasswordSet";

interface RegisterProps {}

export const Register: React.FC<RegisterProps> = () => {
  return <AppraiserPasswordSet type="registration" />;
};
